import {
  ADD_NEW_PAGE,
  FETCH_PAGE_CONTENTS,
  PAGE_UPDATE_STATUS,
  STORE_PAGE_TO_EDIT,
  INITIALIZE_PAGES,
  REMOVE_PAGE_BY_ID,
  VENUE_EVENTS
} from '../actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_NEW_PAGE:
      return {
        ...state,
        ...action.payload
      }
    case FETCH_PAGE_CONTENTS:
      return {
        ...state,
        ...action.payload
      }
    case PAGE_UPDATE_STATUS:
      return {
        ...state,
        ...action.payload
      }
    case STORE_PAGE_TO_EDIT:
      return {
        ...state,
        ...action.payload
      }
    case INITIALIZE_PAGES:
      return {
        ...state,
        venues: action.payload.venues,
        tourVenues: action.payload.tourVenues
      }
    case REMOVE_PAGE_BY_ID:
      return {
        ...state,
        ...action.payload
      }
    case VENUE_EVENTS:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
